import addDays from 'date-fns/addDays'
import addYears from 'date-fns/addYears'

import { customFormat, parseCalendarDate } from 'utils/dateUtils'

export const COLLECTION_PERIOD_MAX_YEARS = 1

const DATE_TIME = /^\d{4}-\d{2}-\d{2}T/

export const toCalendarIso = (value) => {
  if (value == null || value === '') {
    return null
  }
  const raw = String(value)
  const day = DATE_TIME.test(raw) ? raw.slice(0, 10) : raw
  const date = parseCalendarDate(day)
  if (!date) {
    return null
  }
  return customFormat(date, 'yyyy-MM-dd', false)
}

export const getExtendDeadlineBounds = ({ currentDeadline, collectingUntil } = {}) => {
  const deadline = parseCalendarDate(toCalendarIso(currentDeadline || collectingUntil))
  const campaignUntil = parseCalendarDate(toCalendarIso(collectingUntil || currentDeadline))
  if (!deadline || !campaignUntil) {
    return null
  }

  const minDate = customFormat(addDays(deadline, 1), 'yyyy-MM-dd', false)
  const maxDate = customFormat(
    addYears(campaignUntil, COLLECTION_PERIOD_MAX_YEARS),
    'yyyy-MM-dd',
    false
  )
  const canExtend = Boolean(minDate && maxDate && minDate <= maxDate)

  return {
    minDate,
    maxDate,
    defaultDate: canExtend ? minDate : null,
    canExtend,
  }
}

export const currentDateHelper = (formattedDate, { personal } = {}) => {
  if (!formattedDate) {
    return undefined
  }
  return personal
    ? `Current deadline: ${formattedDate}`
    : `Current collecting until: ${formattedDate}`
}

export const extendDeadlineDialogProps = ({
  currentDeadline,
  collectingUntil,
  dateHelper,
} = {}) => {
  const bounds = getExtendDeadlineBounds({ currentDeadline, collectingUntil })
  if (!bounds) {
    return {}
  }

  return {
    minDate: bounds.minDate,
    maxDate: bounds.maxDate,
    initialDate: bounds.defaultDate || undefined,
    dateHelper,
  }
}

export const rowCurrentDeadlineIso = (row, collectingUntilIso) =>
  toCalendarIso(row?.extendedDeadlineIso || row?.effectiveDeadlineIso || collectingUntilIso)

export const latestDeadlineIso = (deadlines, fallbackIso) => {
  const isoDates = [...deadlines, fallbackIso].map(toCalendarIso).filter(Boolean)
  if (!isoDates.length) {
    return null
  }
  return isoDates.sort()[isoDates.length - 1]
}
